(function () {
  var SUCCESS_MESSAGE = 'Cadastro realizado com sucesso.';
  var DUPLICATE_MESSAGE = 'Este e-mail já foi cadastrado.';

  function formatWhatsapp(value) {
    var digits = value.replace(/\D/g, '');

    if (digits.length > 11) {
      digits = digits.slice(0, 11);
    }

    if (digits.length >= 2) {
      digits = '(' + digits.slice(0, 2) + ')' + digits.slice(2);
    }

    if (digits.length > 9) {
      digits = digits.slice(0, 9) + '-' + digits.slice(9);
    }

    return digits;
  }

  function hideFormExtras(overlay) {
    var descriptionEl = overlay.querySelector('[data-sorteio-description]');
    var bottomEl = overlay.querySelector('[data-sorteio-bottom]');

    if (descriptionEl) descriptionEl.hidden = true;
    if (bottomEl) bottomEl.hidden = true;
  }

  function showFormExtras(overlay) {
    var descriptionEl = overlay.querySelector('[data-sorteio-description]');
    var bottomEl = overlay.querySelector('[data-sorteio-bottom]');

    if (descriptionEl) descriptionEl.hidden = false;
    if (bottomEl) bottomEl.hidden = false;
  }

  function hideFeedback(feedbackEl) {
    if (!feedbackEl) return;

    feedbackEl.style.display = 'none';
    feedbackEl.textContent = '';
    feedbackEl.classList.remove('is-error');
  }

  function showFeedback(feedbackEl, message, isError) {
    if (!feedbackEl) return;

    feedbackEl.textContent = message;
    feedbackEl.style.display = 'block';
    feedbackEl.classList.toggle('is-error', !!isError);
  }

  function isDuplicateEmailResponse(data) {
    if (!data || typeof data.mensagem !== 'string') return false;

    return (
      data.mensagem === DUPLICATE_MESSAGE ||
      data.mensagem.toLowerCase().indexOf('já foi cadastrado') !== -1
    );
  }

  function isSuccessResponse(data) {
    return !!(data && data.mensagem === SUCCESS_MESSAGE);
  }

  function closeOverlay(overlay, persistDismiss) {
    overlay.classList.add('is-hidden');

    if (!persistDismiss) return;

    var rememberDismiss = overlay.dataset.rememberDismiss === 'true';
    var dismissKey = overlay.dataset.dismissKey;

    if (rememberDismiss && dismissKey) {
      try {
        localStorage.setItem(dismissKey, 'true');
      } catch (error) {
        /* ignore storage errors */
      }
    }
  }

  function initSorteioLeadForm(overlay) {
    var form = overlay.querySelector('[data-sorteio-form]');
    if (!form) return;

    var webhookUrl = overlay.dataset.webhookUrl;
    var nameErrorMessage = overlay.dataset.nameError;
    var successMessage = overlay.dataset.successMessage;
    var duplicateMessage = overlay.dataset.duplicateMessage;
    var connectionErrorMessage = overlay.dataset.connectionError;
    var autoCloseSuccess = overlay.dataset.autoCloseSuccess === 'true';
    var autoCloseDelay = parseInt(overlay.dataset.autoCloseDelay, 10) || 3500;
    var submitButton = form.querySelector('button[type="submit"]');
    var nameErrorEl = overlay.querySelector('[data-name-error]');
    var feedbackEl = overlay.querySelector('[data-success-message]');
    var nameInput = form.querySelector('[name="name"]');
    var emailInput = form.querySelector('[name="email"]');
    var whatsappInput = form.querySelector('[name="whatsapp"]');
    var stateInput = form.querySelector('[name="state"]');
    var closeButton = overlay.querySelector('[data-sorteio-close]');

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closeOverlay(overlay, true);
      });
    }

    if (whatsappInput) {
      whatsappInput.addEventListener('input', function (event) {
        event.target.value = formatWhatsapp(event.target.value);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      hideFeedback(feedbackEl);

      if (submitButton) submitButton.disabled = true;

      if (nameInput) {
        var nameValue = nameInput.value.trim();

        if (nameValue.split(' ').filter(Boolean).length < 2) {
          if (nameErrorEl) {
            nameErrorEl.textContent = nameErrorMessage;
            nameErrorEl.style.display = 'block';

            window.setTimeout(function () {
              nameErrorEl.style.display = 'none';
            }, 3000);
          }

          if (submitButton) submitButton.disabled = false;
          return;
        }
      }

      var payload = {
        name: nameInput ? nameInput.value.trim() : '',
        email: emailInput ? emailInput.value.trim() : '',
        whatsapp: whatsappInput ? whatsappInput.value.trim() : '',
        state: stateInput ? stateInput.value.trim().toUpperCase() : ''
      };

      fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('request_failed');
          }

          return response.json();
        })
        .then(function (data) {
          if (isDuplicateEmailResponse(data)) {
            showFeedback(feedbackEl, duplicateMessage || data.mensagem, true);
            form.hidden = false;
            showFormExtras(overlay);

            if (emailInput) {
              emailInput.focus();
              emailInput.select();
            }

            if (submitButton) submitButton.disabled = false;
            return;
          }

          if (isSuccessResponse(data)) {
            showFeedback(feedbackEl, successMessage, false);
            form.hidden = true;
            hideFormExtras(overlay);

            if (autoCloseSuccess) {
              window.setTimeout(function () {
                closeOverlay(overlay, true);
              }, autoCloseDelay);
            }

            return;
          }

          showFeedback(
            feedbackEl,
            (data && data.mensagem) || connectionErrorMessage,
            true
          );
          form.hidden = false;
          showFormExtras(overlay);

          if (submitButton) submitButton.disabled = false;
        })
        .catch(function () {
          showFeedback(feedbackEl, connectionErrorMessage, true);
          form.hidden = false;
          showFormExtras(overlay);

          if (submitButton) submitButton.disabled = false;
        });
    });
  }

  function initAll() {
    var overlays = document.querySelectorAll('[data-sorteio-lead-overlay]');

    for (var i = 0; i < overlays.length; i += 1) {
      initSorteioLeadForm(overlays[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var overlay = event.target.querySelector('[data-sorteio-lead-overlay]');
    if (overlay) initSorteioLeadForm(overlay);
  });
})();
